import { FC } from 'react';
import { Button, ButtonProps } from 'antd';

const DangerTextButton: FC<ButtonProps> = ({ title, ...props }) => {
  return (
    <Button type='text' danger {...props}>
      {title}
    </Button>
  );
};

export default DangerTextButton;
